import React from 'react';
import PropTypes from 'prop-types';

import LabeledTextInput from 'components/consumer/LabeledTextInput';

const FirstNameField = ({
  value,
  error,
  isTouched,
  handleBlur,
  handleChange,
  ...props
}) => (
  <LabeledTextInput
    id="first_name"
    name="first_name"
    label="First name *"
    onChange={handleChange}
    onBlur={handleBlur}
    value={value}
    autoComplete="given-name"
    data-xc="shipping-first-name-field"
    errorMessage={isTouched && error ? error : null}
    required
    aria-required
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  />
);

FirstNameField.propTypes = {
  error: PropTypes.string,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  isTouched: PropTypes.bool,
  value: PropTypes.string,
};

export default FirstNameField;
